import axios from 'axios';
import { CONNECTION_TIMEOUT } from '../../config';

const { REACT_APP_GET_CMS_CONTENT_URL } = process.env;

export async function cmsContent() {
  const url: string = REACT_APP_GET_CMS_CONTENT_URL || '';
  const response = await axios.get(url, {
    timeout: CONNECTION_TIMEOUT,
    validateStatus: statusCode => statusCode === 200,
  });

  return response.data;
}
